/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5061024f806100206000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c806352d1902d1461004657806389287e0a146100795780639903ad3814610089575b600080fd5b7fca2aacef54bd44c838311f7274fc12b435395ce38673a3458ccdb318c9e1115f60405190815260200160405180910390f35b6100876100413660046101c5565b005b610087600054610100900460ff16158080156100ac5750600054600160ff909116105b806100c65750303b1580156100c6575060005460ff166001145b61012d5760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b606482015260840160405180910390fd5b6000805460ff191660011790558015610150576000805461ff0019166101001790555b8015610196576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b50565b80356001600160a01b03811681146101b057600080fd5b919050565b803580151581146101b057600080fd5b600080600080608085870312156101db57600080fd5b6101e485610199565b93506101f260208601610199565b9250610200604086016101b5565b915061020e606086016101b5565b90509295919450925056fea264697066735822122009e1871655cfc46ad0654f4f4098ed9dc049a6b89332a2502e413515e35b517364736f6c63430008170033";
const isSuperArgs = (xs) => xs.length > 1;
export class SuperfluidPoolPlaceholder__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
SuperfluidPoolPlaceholder__factory.bytecode = _bytecode;
SuperfluidPoolPlaceholder__factory.abi = _abi;
//# sourceMappingURL=SuperfluidPoolPlaceholder__factory.js.map